import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import Profile from '../../../models/Profile';

export type ProfileState = {
  profile?: Profile | null;
  licenses: GeneralCatalogItem[];
};

const initialState: ProfileState = {
  profile: null,
  licenses: [],
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    updateProfileData: (state, action: PayloadAction<Profile | null>): void => {
      state.profile = action.payload;
    },
    updateLicenses: (
      state,
      action: PayloadAction<GeneralCatalogItem[]>,
    ): void => {
      state.licenses = action.payload;
    },
  },
});

export const { updateProfileData, updateLicenses } = profileSlice.actions;

export default profileSlice.reducer;
